<template>
    <div v-if="simulation">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row" v-if="$permissions.hasRight('dashboard.learners.read')">
                <div class="col-lg-6 order-lg-2">
                    <simulation ref="simulation1"
                        :registration="registration"
                        :simulation="simulation"
                        :competencies="competencies">
                    </simulation>
                    <sessions
                        :registration="registration"
                        :simulation="simulation"
                        :simulations="simulations"
                        :sessions="sessions"
                        :learners="learners"
                        @sharedFeedbacks="$refs.simulation1.setSharedFeedbacks($event)"
                    >
                    </sessions>
                </div>
                <div class="col-lg-6 order-lg-1">
                    <groups :registration="registration" :groups="groups" :learners="learners"></groups>
                    <learners
                        :registration="registration"
                        :simulation="simulation"
                        :learners="learners"
                    ></learners>
                </div>
            </div>

            <div class="row" v-else>
                <div class="col-lg-12">
                    <simulation ref="simulation2"
                        :registration="registration"
                        :simulation="simulation"
                        :competencies="competencies">
                    </simulation>
                    <sessions
                        :registration="registration"
                        :simulation="simulation"
                        :simulations="simulations"
                        :sessions="sessions"
                        :learners="learners"
                        @sharedFeedbacks="$refs.simulation2.setSharedFeedbacks($event)"
                    >
                    </sessions>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Learners from './cohort/SimulationLearners'
    import Simulation from './cohort/Simulation';
    import Groups from './cohort/GroupsCrud';
    import Sessions from './cohort/SessionsCrud';

    export default {

        components: {
            Learners, Simulation, Groups, Sessions
        },

        data() {
            return {
                simulation: null,
                simulations: null,
                sessions: null,
                registration: null,
                learners: null,
                groups: null,
                competencies: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.$route.params.cohortId
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/cohorts/' + this.$route.params.cohortId
                    },
                    {
                        name: this.simulation.name,
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/simulations/'+to.params.simulationId+'/cohorts/'+to.params.cohortId)
            .then(resp => {
                next(vm => {
                    vm.simulation = resp.data.data
                    vm.simulations = resp.data.included.simulations
                    vm.sessions = resp.data.included.sessions
                    vm.registration = resp.data.included.registration
                    vm.learners = resp.data.included.learners
                    vm.groups = resp.data.included.groups
                    vm.competencies = resp.data.included.competencies
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        }
    }
</script>
